import { Component, OnInit } from '@angular/core';
import {ExtractionService} from '../../../services/configuration/extraction.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {CustomValidator} from '../../../services/custom-validator';
import {Utils} from '../../../services/utils';
import {WebClientConfigurationService} from '../../../services/configuration/web-client-configuration.service';
import {PaginationInstance} from 'ngx-pagination';
import {tap} from 'rxjs/operators';
import {EnumTranslateService} from '../../../services/enumTranslate-service';
import {DateTimeService} from '../../../services/date-time.service';
import {GenericModalService} from '../../../services/generic-modal.service';
import {ErrorMessageModalComponent} from './error-message-modal/error-message-modal.component';

@Component({
  selector: 'app-task-monitoring',
  templateUrl: './task-monitoring.component.html',
  styleUrls: ['./task-monitoring.component.css']
})
export class TaskMonitoringComponent implements OnInit {

  private translateEnum = EnumTranslateService;
  utils = Utils;
  filterForm: FormGroup;
  dataExtractionDefinition;
  errorMessage = '';
  pleaseWait = '';
  allTasksList = [];
  loadingList = false;
  searchClicked = false;
  config: PaginationInstance;
  refreshTime;
  lastFilter;
  private _refresh = null;

  static get currentDayInterval() {
    let now = new Date();
    return {
      start: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)).toISOString().substr(0, 19),
      end: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)).toISOString().substr(0, 19)
    };
  };
  get formData() { return this.filterForm.controls; }

  constructor(private extractionService: ExtractionService, private formBuilder: FormBuilder,
              private webClientConfig: WebClientConfigurationService, private dateTimeService: DateTimeService,
              private modalService: GenericModalService) { }

  ngOnInit() {
    this.createForm();
    this.getAllDataExtraction();
  }

  createForm() {
    this.filterForm = this.formBuilder.group({
      taskId: null,
      initialStartTime: TaskMonitoringComponent.currentDayInterval.start,
      finalStartTime: TaskMonitoringComponent.currentDayInterval.end
    }, { validators: [
      CustomValidator.validateDatetime('initialStartTime', 'finalStartTime')
      ]
    });
  }

  getAllDataExtraction() {
    this.extractionService.getAllDataExtractionDefinition()
      .subscribe(res => {
        this.dataExtractionDefinition = res;
      }, error1 => this.errorMessage = error1);
  }

  blockUserInput() {
    return;
  }

  resetFilter() {
    this.createForm();
  }

  onSearch(page: number, buttonSearchClicked = true) {
    // let _refresh = null;
    this.errorMessage = '';
    this.loadingList = true;
    this.searchClicked = true;
    let filter = null;

    if (buttonSearchClicked) {
      filter = this.filterForm.getRawValue();
      filter.initialStartTime = this.dateTimeService.toUTC(filter.initialStartTime);
      filter.finalStartTime = this.dateTimeService.toUTC(filter.finalStartTime);
      filter.pageIndex = page;

      this.lastFilter = filter;
    } else {
      filter = this.lastFilter;
    }

    this.extractionService.pagedTasksSearch(filter)
      .pipe(tap( res => {
        this.getPaginationConfig(filter.pageIndex, res.total);
      }))
      .subscribe(ret => {
        this.loadingList = false;
        this.allTasksList = ret.items.sort((n1, n2) => {
          if (n1.name > n2.name) {
            return 1;
          }

          if (n1.name < n2.name) {
            return -1;
          }

          return 0;
        });

        // fechar o filtro
        if (buttonSearchClicked) {
          Utils.closeFilter();
        }

        this.refreshTime = new Date();

        if (this._refresh)
        {
          clearTimeout(this._refresh);
        }
        this._refresh = setTimeout(() => { this.onSearch(filter.pageIndex, false) }, 20000);

      }, error1 => {
        this.errorMessage = error1;
        setTimeout(() => { this.errorMessage = '' }, 2000);
      });
  }

  getPaginationConfig(_currentPage: number, _totalItems: number) {
    this.errorMessage = '';
    this.webClientConfig.getPageSizeConfig().subscribe(item => {
      this.config  = {
        id: 'server',
        itemsPerPage: item,
        currentPage: _currentPage,
        totalItems: _totalItems
      };
    }, error1 => this.errorMessage = '');
  }

  adjustDate(isInitialDate = true) {
    // alterar depois para todos os lugares que tem período
    Utils.adjustDate(isInitialDate, this.filterForm, 'initialStartTime', 'finalStartTime');
    console.log(this.filterForm.getRawValue());
  }

  downloadTaskDataExtraction(taskData) {
    this.errorMessage = '';
    this.extractionService.downloadTaskDataExtraction(taskData.replaceAll('\\', '%2F'))
      .subscribe(data => {
        const fileName = taskData.split('\\').pop();
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = encodeURIComponent(fileName);
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
    }, error1 => this.errorMessage = error1);
  }

  generatePercentGraph(specific, total) {
    let html = '<div style="border: 1px solid #000; height: 12px;">';
    const percent = (specific / total) * 100;
    const width = this.getPercentBasedWidth(percent);
    if (percent > 0) {
      html += `<div class="graphCell">
                  <div class="graphBar" style="width:${width}%; background-color: #17a2b8; height: 10px;"></div>
                </div>`;
    }
    html += '</div>';
    return html;
  }

  generatePercentLabel(specific, total) {
    const percent = (specific / total) * 100;
    let label = percent.toFixed(2).replace('.', ',');
    if (label.toString().indexOf(',00') > -1) {
      label = label.replace(',00', '');
    }
    return `${label}% concluído`;
  }

  getPercentBasedWidth(item) {
    return (item / 100) * parseInt('100', 10) || 100;
  }

  showErrorMessage(errorMessage) {
    const errorComponent: any = ErrorMessageModalComponent;
    const objInitialState = errorMessage;
    this.modalService.showObjModal(errorComponent, `Filtro rápido`, objInitialState, 'modal-md')
  }

}
